import React, { FC, useState, useEffect } from 'react';
import { ArticlePdfComponent } from './types';
import { PdfViewer } from 'components/base/PdfViewer';
import { useRecord } from 'hooks/useRecord';

export const ArticlePdf: FC<ArticlePdfComponent> = ({
  id: articleId, onLoadSuccess,
}) => {
  const { getArticlePdf, base64Pdf } = useRecord();
  const [pdfStream, setPdfStream] = useState<string>();

  useEffect(() => {
    setPdfStream(base64Pdf);
  }, [base64Pdf]);

  useEffect(
    () => {
      if (articleId) {
        getArticlePdf(articleId)
          .catch(() => false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [articleId],
  );

  return (
    <div>
      {pdfStream && <PdfViewer base64={pdfStream} onLoadSuccess={onLoadSuccess} />}
    </div>
  );
};
